import { render, staticRenderFns } from "./PriceListProposalStatus.vue?vue&type=template&id=60bf702b&functional=true"
import script from "./PriceListProposalStatus.vue?vue&type=script&lang=js"
export * from "./PriceListProposalStatus.vue?vue&type=script&lang=js"
import style0 from "./PriceListProposalStatus.vue?vue&type=style&index=0&id=60bf702b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports